export const WEEKDAYS = [
  { key: 'lunes', label: 'Lun', fullLabel: 'Lunes' },
  { key: 'martes', label: 'Mar', fullLabel: 'Martes' },
  { key: 'miercoles', label: 'Mié', fullLabel: 'Miércoles' },
  { key: 'jueves', label: 'Jue', fullLabel: 'Jueves' },
  { key: 'viernes', label: 'Vie', fullLabel: 'Viernes' },
  { key: 'sabado', label: 'Sáb', fullLabel: 'Sábado' },
  { key: 'domingo', label: 'Dom', fullLabel: 'Domingo' },
] as const;
